import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformationComponent } from './information.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
      path: '',
      component: InformationComponent,
      data: {
          title: 'Information'
      }
  }
];
@NgModule({
  declarations: [InformationComponent],
  imports: [
    BrowserModule,
    CommonModule,    
    RouterModule.forChild(routes)
  ]
})
export class InformationModule { }
